export interface IProductCategoryLicense {
 id?: number
 key: string
 state: number
 state_name?: string
 district: number
 district_name?: string
 product_category: number
 license_number: string
 expiry_date: Date | string | null
 business_group?: string
 business_service?: string | null
 license_document: string
 license_document_url?: string
 is_verified?: boolean
}

export interface ILicenseDeleteRequest {
 license_id: number
 user_id?: number
}

export interface INetworkProfileTable {
 id?: number
 srNo: number
 phone_number?: string
 is_active?: boolean
 organisation_mapping_created_since: string
 stakeholder: string
 category?: string
 user_category: string
 organisation?: string
 organisation_id?: string
}

export interface IOrganisationMappingCount {
 organisation_type: string
 mapping_count: number
}

export interface IInfra {
 id?: number
 infra_type: string
 state: number
 state_name?: string
 district: number
 district_name?: string
 pincode: string
 address?: string
 gst_no?: string
 gst_certificate?: string
 is_active?: boolean
}

export interface IInfraUpdateRequest {
 user_id?: number
 infra_data: IInfra[]
}

export interface IInfraDeleteRequest {
 user_id?: number
 infra_ids: number[]
}

export const PAYMENT_TERMS_DOCUMENT_TYPE =
 'PAYMENT_TERMS_AND_CONDITIONS'

export interface IOrganisationDocument {
 id: number
 organisation: number
 document_type: string
 document_url: string
 status: string
 created_by?: number
 updated_by?: number
 created_at?: string
 updated_at?: string
}

export type CreateOrganisationDocumentPayload = {
 organisation: number
 document_type: string
 document_url: string
 status: string
}

export type UpdateOrganisationDocumentPayload = {
 id: number
 document_type: string
 document_url: string
 status: string
}
